import { render, staticRenderFns } from "./Divers.html?vue&type=template&id=2fc2216f&lang=html&external"
import script from "./Divers.vue?vue&type=script&lang=js"
export * from "./Divers.vue?vue&type=script&lang=js"
import style0 from "./Divers.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports